import type { TimeBlock } from "./db";
import { MAX_PLANNED_MIN } from "./focus-timer";

// What a planned block can launch (5.7): focus and task blocks start a
// focus session sized to the block; study blocks open the Study screen.

export type BlockAction =
	| { kind: "focus"; minutes: number; task_id: string | null; label: string }
	| { kind: "study"; label: string }
	| null;

type BlockLike = Pick<TimeBlock, "kind" | "task_id" | "start_at" | "end_at">;

/** The block's length rounded to 5 minutes, kept within what a session allows. */
export function blockMinutes(b: Pick<TimeBlock, "start_at" | "end_at">): number {
	const min = (Date.parse(b.end_at) - Date.parse(b.start_at)) / 60_000;
	return Math.min(MAX_PLANNED_MIN, Math.max(5, Math.round(min / 5) * 5));
}

export function blockAction(b: BlockLike): BlockAction {
	switch (b.kind) {
		case "focus":
		case "task":
			return { kind: "focus", minutes: blockMinutes(b), task_id: b.task_id, label: "Start focus" };
		case "study":
			return { kind: "study", label: "Study" };
		default:
			return null; // breaks and "other" have nothing to launch
	}
}

export const BLOCK_KIND_LABELS: Record<TimeBlock["kind"], string> = {
	task: "Task",
	focus: "Focus",
	study: "Study",
	break: "Break",
	other: "Other",
};
